import { useCallback, useState } from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'
import {
  Toolbar,
  TopToolbar,
  ImageField,
  ImageInput,
  useDataProvider,
  SaveButton,
  DeleteButton,
  Pagination,
  useRecordContext,
} from 'react-admin'
import { Button as ButtonM } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { Link as LinkM } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { useRefresh, useNotify } from 'ra-core'
import InputLabel from '@material-ui/core/InputLabel'
import { FieldTitle } from 'ra-core'
import Grid from '@material-ui/core/Grid'
import GetAppIcon from '@mui/icons-material/GetApp'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import CheckIcon from '@mui/icons-material/Check'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { phone } from 'phone'
import PasswordDialog from './components/common/Dialogs/PasswordDialog'
import FileWithContext from './models/file_with_context'
import config from './config'
export const isEmpty = (val) => {
  if (typeof val === 'object') {
    return Object.keys(val).length === 0
  } else if (Array.isArray(val)) {
    return val.length == 0
  } else if (typeof val == 'string') {
    return val.length == 0
  } else if (typeof val == 'number') {
    return val == 0
  } else if (!val) {
    return true
  }
  return false
}

export const openUrl = (url) => (window.location = url)

export const openInNewTab = (url) => {
  var win = window.open(url, '_blank')
  win.focus()
}

export const removeDuplicates = (arr) => {
  var unique_set = new Set(arr)
  return [...unique_set]
}

export const coproChoices = async (copro_id) => {
  if (copro_id === undefined) {
    return []
  } else {
    const response = await fetch(
      config.API_V1 + '/coproprietaires_frommonday/' + copro_id
    )
    const results = await response.json()
    var choices = results.map((v) => {
      return {
        id: v.id,
        name: v.name,
      }
    })
    return choices
  }
}

export const url = config.PUBLIC_URL + '/img/logo_blanc.png'
export const url2 = config.PUBLIC_URL + '/img/logo.png'
export const urlQrCode = config.PUBLIC_URL + '/img/qr-code.jpeg'

export const draft_color = '#FCF5E5'

export const espacesUniquesKeys = {
  prestas: '/ext_prestas',
  cs: '/ext_tickets',
  ag: '/ext_ags2',
  ag2: '/ag',
  ag3: '/AG',
  pvag: '/pvags',
  mec: '/mec',
  copro: '/ext_coprosummary',
  coprotickets: '/ext_copro_tickets',
  invoices: '/ext_copro_invoices',
  coproprietaires: '/ext_coproprietaires',
  ext_login: '/ext_login',
  coprofiche: '/ext_copros_fiche',
  frontplugintickets: '/frontplugin_tickets',
  concent_template: '/concent_template',
  zendesk_plugin_tickets: '/zendesk_plugin_tickets',
}
export const espacesUniquesNames = {
  pvags: "PV d'AG",
  mec: 'Mise en concurrence',
  copro: "Plan d'action copropriété",
  coproprietaires: 'Hello App',
  coprofiche: 'Fiche Immeuble',
  coprotickets: 'Demander une intervention',
  invoices: 'Factures copro',
  frontplugintickets: 'Créer ticket',
}

export const espaceUniquePrestaPrefix = (ticket) => {
  return (
    window.location.origin +
    '/' +
    espacesUniquesKeys['presta'] +
    '/' +
    ticket.unique_token
  )
}
export const espaceUniqueCsPrefix = (ticket) => {
  return (
    window.location.origin +
    '/' +
    espacesUniquesKeys['cs'] +
    '/' +
    ticket.unique_token2
  )
}

export const DownloadField = (props) => {
  if (props.record.process1_file1 === undefined) {
    return null
  }
  return (
    <a href={`${props.record.process1_file1}`} download={'imageName'}>
      Télécharger
    </a>
  )
}
export const DownloadField2 = (props) => {
  if (props.record.process1_file2 === undefined) {
    return null
  }
  return (
    <a href={`${props.record.process1_file2}`} download={'imageName'}>
      Télécharger
    </a>
  )
}
export const DownloadField3 = (props) => {
  if (props.record.signature === undefined) {
    return null
  }
  return (
    <a href={`${props.record.signature}`} download={'imageName'}>
      Télécharger
    </a>
  )
}
export const DownloadField4 = (props) => {
  if (props.record.base64 === undefined) {
    return null
  }
  return (
    <a href={`${props.record.base64}`} download={'imageName'}>
      Télécharger
    </a>
  )
}

export const EmptyActions = (props) => {
  const { basePath, hasList, hasEdit, hasShow, ...rest } = props
  return <div {...rest} />
}

export const formatLogo = (value) => {
  if (!value || typeof value === 'string') {
    // Value is null or the url string from the backend, wrap it in an object so the form input can handle it
    return { url: value }
  } else {
    // Else a new image is selected which results in a value object already having a preview link under the url key
    return value
  }
}

export const CustomToolbar = (props) => {
  const { collapse } = props
  return (
    <Toolbar {...props}>
      <SaveButton {...props} icon={<CheckIcon />} type="submit" />
    </Toolbar>
  )
}

export const CustomToolbarOnlyDelete = (props) => (
  <Toolbar {...props}>
    <DeleteButton redirect={false} />
  </Toolbar>
)

export const fieldWidth = '255px'

//value is i [0,1]
export const StatusProgress = (props) => {
  const value = Math.floor(100 * parseFloat(props.value))

  return (
    <LinearProgress
      variant="buffer"
      value={value}
      valueBuffer={value}
      color="primary"
      style={{ width: fieldWidth }}
    />
  )
}

export const StatusProgressV2 = (props) => {
  const { process_nb_states, process_states, status, archived } = props.ticket
  let { step_rank } = props.ticket
  const isOnMobile = useMediaQuery('(max-width:500px)')
  // If it's archived I change the state to the lastone to show them as finished.
  if (archived) step_rank = process_states.length
  let steps = []
  for (let k = 0; k < process_states.length; k++) {
    steps.push({
      id: k,
      label: process_states[k],
    })
  }

  return (
    <Stepper
      activeStep={step_rank - 1}
      orientation={isOnMobile ? 'vertical' : 'horizontal'}
      alternativeLabel={!isOnMobile}
    >
      {steps.map((s) => (
        <Step key={s.id}>
          <StepLabel>{s.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export const Emoji = (props) => (
  <span
    className="emoji"
    role="img"
    aria-label={props.label ? props.label : ''}
    aria-hidden={props.label ? 'false' : 'true'}
  >
    {props.symbol}
  </span>
)

export const OpenFrontAppButton = (props) => {
  return (
    <Typography>
      <a
        target="_blank"
        href={'https://app.frontapp.com/open/' + props.record.content}
        rel="noreferrer"
      >
        Ouvrir dans FrontApp{' '}
      </a>
    </Typography>
  )
}

//NOTE: In SimpleShowLayout, label is not displayed if we use Field wrappers, so we add the label oursevles.
//However in Edit/SimpleForm, using InputWrappers is not problematic. I don't know why
export const Label = (props) => {
  const { className } = props
  return (
    <InputLabel className={className}>
      <FieldTitle label={props.label} source={props.source} />
    </InputLabel>
  )
}

export const currencyFormatter = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'EUR',
})

export const buildUrl = (st) => {
  var st2 = st.replace('/uploads/', window.location.origin + '/files/')
  var st3 = st2.replace('/uploadspb/', window.location.origin + '/filespb/')
  return st3
}

export const buildFilename = (st) => {
  var st2 = st.replace('/uploads/', '')
  var st3 = st2.replace('/uploadspb/', '')
  var filename = st3.split('_').splice(1).join('_')
  if (filename.length < 15) {
    return filename
  } else {
    return filename.substring(0, 12) + '...'
  }
}

export const DisplayVPCLink = (props) => {
  const { vpc_form_filepath } = useRecordContext(props)

  if (vpc_form_filepath === null) return null
  const url = buildUrl(vpc_form_filepath)

  const onClick = () => {
    window.open(url, '_blank')
  }
  return <ButtonM onClick={onClick}>Formulaire VPC</ButtonM>
}

const DisplayLinks = (props) => {
  const { from, record, source } = props
  const refresh = useRefresh()
  const notify = useNotify()
  const dataProvider = useDataProvider()
  const [openDialogConfirmPassowrd, setOpenDialogConfirmPassowrd] =
    useState(false)
  if (!record) return null
  const files = record[source]
  if (files === undefined) {
    return null
  }
  if (files === null) {
    return null
  }

  const func = (f) =>
    dataProvider
      .update('files', {
        id: props.record.id,
        data: {
          source: props.source,
          filename: f,
          from: from,
        },
      })
      .then((response) => {
        notify('Succès')
        refresh()
      })
      .catch((error) => {
        notify(`${error.message}`, 'warning')
      })

  return (
    <div>
      {files.map((f, index) => {
        if (f === '') {
          return null
        }
        //means file was just dragged and dropped
        if (f.rawFile !== undefined) {
          return null
        }
        var url = buildUrl(f)
        var filename = buildFilename(f)
        return (
          <div key={index}>
            <Typography variant="h6">
              <GetAppIcon style={{ marginBottom: '-5px' }} />
              <PasswordDialog
                open={openDialogConfirmPassowrd}
                setOpen={setOpenDialogConfirmPassowrd}
                onConfirm={() => {
                  openInNewTab(url)
                }}
              />
              <LinkM
                href={props.protected ? '' : url}
                target="_blank"
                color="inherit"
                onClick={(e) => {
                  e.preventDefault()
                  if (props.protected) {
                    setOpenDialogConfirmPassowrd(true)
                  } else {
                    openInNewTab(url)
                  }
                }}
              >
                {filename}
              </LinkM>
              {props.deletable === true ? (
                <ButtonM
                  style={{
                    width: '40px',
                    minWidth: '40px',
                    height: '20px',
                    margin: '5px',
                    marginBottom: '10px',
                  }}
                  onClick={() => func(f)}
                >
                  Supp.
                </ButtonM>
              ) : null}
            </Typography>
          </div>
        )
      })}
    </div>
  )
}

export const ImageFieldCustom = ({ timestamp, label, source, ...props }) => {
  const record = useRecordContext(props)
  if (!record) return null

  return (
    <div>
      <br />
      <Label {...props} source={source} label={label} record={record} />
      <br />
      <DisplayLinks
        {...props}
        source={source}
        record={record}
        deletable={false}
      />
    </div>
  )
}

//NOTE: we put a fixed width here so that the image upload form
//does not occupy full form width in BO ticket create form
//else subform for process-specific fields becomes too large
//NOTE: files can be deletable only on BO side, not on extranet side.
//Else we would have to make a specific endpoint ext_files that would act
//on ticket_process_cols instead of copros, we didn't have time to do that yet.
export const ImageInputCustom = (props) => {
  const record = useRecordContext(props.record)
  if (!record) return null
  const { from, source, label } = props

  var deletable = false
  if (from === 'copros_fiche') {
    deletable = true
  }
  if (from === 'contracts') {
    deletable = true
  }

  return (
    <div {...props} style={{ width: '290px' }}>
      <ImageInput {...props} source={source} label={label} multiple={true}>
        <ImageField source="src" title="title" />
      </ImageInput>
      <DisplayLinks {...props} from={props.from} deletable={deletable} />
    </div>
  )
}
//When we don't want user to see previously uploaded documents
export const ImageInputCustomFireForget = (props) => {
  const { record, source, label } = props

  return (
    <div {...props} style={{ width: '290px' }}>
      <ImageInput {...props} source={source} label={label} multiple={true}>
        <ImageField source="src" title="title" />
      </ImageInput>
    </div>
  )
}

export const ProcessCreateButtonWithState = ({ record }) => (
  <ButtonM
    component={Link}
    to={{
      pathname: '/tickets/create',
      state: { ...record },
    }}
  >
    Créer
  </ButtonM>
)

export const EmptyShowActions = ({ basePath, data, resource }) => (
  <TopToolbar></TopToolbar>
)

export const ExtraPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200]} {...props} />
)
export const NoPagination = (props) => {
  return null
}

//The grid lvl1 makes sure grid lvl2 is centered.
//Grid lvl2 ensures the specified grid size is occupied (with xs and md)
//grid lvl2 alignItems can have 2 values:
// - center if we want children to be centered within the specified grid width with xs etc
// - stretch if we want children to have all same width (specified grid width with xs etc)
// center is useful for example when all children are buttons with fixed width.
// Buttons with fixed width have a div that grow but button itself stays same size so here stretch wont work
export const ExtranetContainer = (props) => {
  const { alignItems } = props
  const children = Array.isArray(props.children)
    ? props.children
    : [props.children]

  var alignItemsVar = alignItems === undefined ? 'center' : alignItems
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
    >
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems={alignItemsVar}
        justify="center"
        xs={props.xs}
        md={props.md}
      >
        {children.map((child, index) => {
          return (
            <Grid item key={index}>
              {child}
              <br />
            </Grid>
          )
        })}
      </Grid>
    </Grid>
  )
}

export const compareProcesses = (a, b) => {
  if (a.nb_active_tickets > b.nb_active_tickets) return -1
  if (b.nb_active_tickets > a.nb_active_tickets) return 1
  return 0
}

export const CreateToolbar = (props) => {
  const handleClick = (event) => {
    if (props.handleSubmit) props.handleSubmit(props.redirect)
  }
  return (
    <Toolbar>
      <ButtonM
        onClick={handleClick}
        color="primary"
        variant="contained"
        disableElevation
        type="submit"
      >
        Enregistrer &nbsp; <Emoji label="ok" symbol="👌" />
      </ButtonM>
    </Toolbar>
  )
}

export const InvoiceLinks = (props) => {
  if (
    !props.record ||
    undefined === props.record[props.source] ||
    null === props.record[props.source]
  )
    return null
  if (typeof props.record[props.source] === 'string')
    props.record[props.source] = [props.record[props.source]]
  return (
    <div>
      {props.record[props.source].map((f, index) => {
        //Can happen when react-admin updates states with payload that was sent to api
        //while it waits for api response. This means we end up having for a short moment
        //file objects (what was sent to api) instead of strings
        if (typeof f !== 'string') return null
        const url = buildUrl(f)
        const filename = buildFilename(f)
        return (
          <div key={index}>
            <Typography variant="h6">
              <Link href={url} target="_blank" color="inherit">
                {filename}
              </Link>
            </Typography>
          </div>
        )
      })}
    </div>
  )
}

export const validatePhone = (value) => {
  if (!value || !value.replaceAll('.', '').replaceAll(' ', '').trim())
    return null
  let phoneNumber = `${value.replaceAll('.', '').replaceAll(' ', '').trim()}`
  let phoneCheck = phone(phoneNumber, {
    validateMobilePrefix: false,
    country: 'FR',
  })
  let valid = phoneCheck.isValid
  return valid
    ? null
    : 'Numéro invalide. Format attendu [+][indicatif de pays][numero]'
}

export const formatPhone = (value) => {
  if (!value || !value.replaceAll('.', '').replaceAll(' ', '').trim())
    return null
  let phoneNumber = value.trim().replaceAll('.', '').replaceAll(' ', '')
  return phone(phoneNumber, { validateMobilePrefix: false, country: 'FR' })
    .phoneNumber
}
export const injectFormData = (formData, jsonObject) => {
  for (var key of Object.keys(jsonObject)) {
    let value = jsonObject[key]
    if (typeof value === 'object') {
      jsonObject[key] = injectFormData(formData, value)
    } else {
      if (
        value == 'replaced' &&
        formData &&
        Object.prototype.hasOwnProperty.call(formData, key)
      ) {
        console.log(`FOUND ${key}`, formData)
        jsonObject[key] = formData[key]
      }
    }
  }
  return jsonObject
}
export const clean = (payload) => {
  // remove all blank attributes from object and returning new one
  // https://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript
  payload = Object.entries(payload).reduce(
    (a, [k, v]) => (v ? ((a[k] = v), a) : a),
    {}
  )
  return payload
}

export const filterTypesByCategories = (categories, defaultTypes) => {
  let new_type = []
  let flagIncludes = false
  if (categories.includes(FileWithContext.CATEGORY.ACCOUNTING)) {
    flagIncludes = true
    new_type = [
      ...new_type,
      ...defaultTypes.filter(
        (t) =>
          [
            FileWithContext.TYPE.QUOTE,
            FileWithContext.TYPE.INVOICE,
            FileWithContext.TYPE.INDIVIDUAL_BURDEN_DISTRIBUTIONS,
            FileWithContext.TYPE.BANK_STATEMENTS,
            FileWithContext.TYPE.OTHERS,
          ].indexOf(t.id) > -1
      ),
    ]
  }
  if (categories.includes(FileWithContext.CATEGORY.TECHNICAL)) {
    flagIncludes = true
    new_type = [
      ...new_type,
      ...defaultTypes.filter(
        (t) =>
          [
            FileWithContext.TYPE.INTERVENTION_REPORT,
            FileWithContext.TYPE.ANALYSIS_OR_EXPERT_REPORT,
            FileWithContext.TYPE.INTERVENTION_PHOTO,
            FileWithContext.TYPE.OTHERS,
          ].indexOf(t.id) > -1
      ),
    ]
  }
  if (categories.includes(FileWithContext.CATEGORY.LEGAL)) {
    flagIncludes = true
    new_type = [
      ...new_type,
      ...defaultTypes.filter(
        (t) =>
          [
            FileWithContext.TYPE.RH_MONITORING,
            FileWithContext.TYPE.RH_PENSION,
            FileWithContext.TYPE.RH_SECURITY,
            FileWithContext.TYPE.RH_WORK_CONTRACT,
            FileWithContext.TYPE.OTHERS,
          ].indexOf(t.id) > -1
      ),
    ]
  }
  if (categories.includes(FileWithContext.CATEGORY.BUILDING)) {
    flagIncludes = true
    new_type = [
      ...new_type,
      ...defaultTypes.filter(
        (t) =>
          [
            FileWithContext.TYPE.REGISTRATION,
            FileWithContext.TYPE.OTHERS,
          ].indexOf(t.id) > -1
      ),
    ]
  }
  if (categories.includes(FileWithContext.CATEGORY.OTHER)) {
    flagIncludes = true
    new_type = [
      ...new_type,
      ...defaultTypes.filter(
        (t) => [FileWithContext.TYPE.OTHERS].indexOf(t.id) > -1
      ),
    ]
  }
  if (categories.includes(FileWithContext.CATEGORY.ADMINISTRATIVE)) {
    flagIncludes = true
    new_type = [
      ...new_type,
      ...defaultTypes.filter(
        (t) => [FileWithContext.TYPE.QUOTE].indexOf(t.id) > -1
      ),
    ]
  }

  return flagIncludes ? new_type : defaultTypes
}
export function isInExtranet(location) {
  if (
    location.pathname.indexOf('/pvags/') !== -1 ||
    location.pathname.indexOf('/pvagsconvocation/') !== -1 ||
    location.pathname.indexOf('/pvagsfeuillepresence/') !== -1 ||
    location.pathname.indexOf('/convocation/') !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['prestas']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['ext_login']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['cs']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['ag']) !== -1 ||
    location.pathname.indexOf('/convocation/') !== -1 ||
    location.pathname === espacesUniquesKeys['ag2'] ||
    location.pathname === espacesUniquesKeys['ag3'] ||
    location.pathname.indexOf(espacesUniquesKeys['pvag']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['mec']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['copro']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['coproprietaires']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['coprofiche']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['coprotickets']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['invoices']) !== -1 ||
    location.pathname.indexOf(espacesUniquesKeys['frontplugintickets']) !==
      -1 ||
    location.pathname.indexOf(espacesUniquesKeys['zendesk_plugin_tickets']) !==
      -1 ||
    location.pathname.indexOf(espacesUniquesKeys['concent_template']) !== -1
  ) {
    return true
  }
  return false
}

// This utility function converts the base64 string to a Uint8Array
export const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  //eslint-disable-next-line
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}
